import { Pause, Play } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";

export const PlayButton = ({ episode, size = "md", variant = "round", testId }) => {
  const { play, isPlaying } = usePlayer();
  const active = isPlaying(episode.id);
  const isVideo = !!episode.video_id && !episode.audio_url;
  const onClick = (e) => { e.preventDefault(); e.stopPropagation(); play(episode); };

  if (variant === "wide") {
    return (
      <button
        onClick={onClick}
      disabled={!episode.audio_url && !episode.video_id}
        className={`w-full h-6 rounded-md flex items-center justify-center gap-1.5 text-[11px] font-semibold tracking-wide transition-colors duration-200 disabled:opacity-40 border ${active ? "bg-sky-400/15 border-sky-400/40 text-sky-300" : "bg-white/[0.04] border-white/10 text-slate-300 hover:bg-white/10 hover:text-white hover:border-white/20"}`}
        data-testid={testId}
        aria-label={active ? "Pause episode" : "Play episode"}
      >
        {active ? <Pause size={11} fill="currentColor" /> : <Play size={11} fill="currentColor" />}
        {active ? "Pause" : isVideo ? "Watch" : "Play"}
      </button>
    );
  }

  const dims = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-9 w-9" : "h-11 w-11";
  const icon = size === "lg" ? 24 : size === "sm" ? 14 : 18;
  return (
    <button
      onClick={onClick}
      disabled={!episode.audio_url && !episode.video_id}
      className={`${dims} rounded-full flex items-center justify-center shrink-0 transition-transform duration-200 hover:scale-110 disabled:opacity-40 ${active ? "bg-amber-400 text-[#070F1E]" : "bg-sky-400 text-[#070F1E]"}`}
      data-testid={testId}
      aria-label={active ? "Pause episode" : "Play episode"}
    >
      {active ? <Pause size={icon} fill="currentColor" /> : <Play size={icon} fill="currentColor" className="ml-0.5" />}
    </button>
  );
};
